// extracted by mini-css-extract-plugin
var _1 = "RentalPortalViewRegimeControl-moduleRentalPortalViewRegimeControl__waaUF";
var _2 = "RentalPortalViewRegimeControl-moduleactive__saDqF";
export { _1 as "RentalPortalViewRegimeControl", _2 as "active" }
